import { useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../api";

function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState("");
  const [error, setError] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [done, setDone] = useState(false);

  const handleStep1 = async (e) => {
    e.preventDefault();
    setError("");
    if (!identifier) {
      setError("Enter your username or phone number");
      return;
    }
    try {
      await auth.forgotPassword(identifier, identifier);
      setStep(2);
    } catch (err) {
      setError(err.message || "No account found");
    }
  };

  const handleStep2 = async (e) => {
    e.preventDefault();
    setError("");
    if (newPass.length < 4) {
      setError("Password must be at least 4 characters");
      return;
    }
    if (newPass !== confirmPass) {
      setError("Passwords do not match");
      return;
    }
    try {
      await auth.resetPassword(identifier, identifier, newPass, confirmPass);
      setDone(true);
    } catch (err) {
      setError(err.message || "Password reset failed");
    }
  };

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-card" style={{ textAlign: "center" }}>
          <h2>Password Reset Successful</h2>
          <p style={{ color: "var(--text-muted)", margin: "12px 0 20px" }}>
            You can now log in with your new password.
          </p>
          <Link to="/login" className="auth-submit" style={{ display: "inline-block", textAlign: "center" }}>
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 style={{ marginBottom: 8 }}>Forgot Password</h2>

        {step === 1 && (
          <>
            <p style={{ color: "var(--text-muted)", marginBottom: 20, fontSize: "0.9rem" }}>
              Enter your username or phone number to verify your account.
            </p>
            {error && <p className="auth-error">{error}</p>}
            <form onSubmit={handleStep1} className="auth-form">
              <label>
                Username or Phone
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  required
                  placeholder="Enter your username or phone"
                />
              </label>
              <button type="submit" className="auth-submit">Verify Account</button>
              <Link to="/login" className="forgot-link" style={{ textAlign: "center", display: "block" }}>
                Back to Login
              </Link>
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <p style={{ color: "var(--gold)", marginBottom: 20, fontSize: "0.9rem" }}>
              Account found! Set your new password.
            </p>
            {error && <p className="auth-error">{error}</p>}
            <form onSubmit={handleStep2} className="auth-form">
              <label>
                New Password
                <input
                  type="password"
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                  required
                  placeholder="At least 4 characters"
                />
              </label>
              <label>
                Confirm New Password
                <input
                  type="password"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                  required
                  placeholder="Re-enter new password"
                />
              </label>
              <button type="submit" className="auth-submit">Reset Password</button>
              <button type="button" className="auth-submit" style={{ background: "var(--navy-border)" }} onClick={() => { setStep(1); setError(""); }}>
                Back
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
